var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"history"},[_c('div',{staticClass:"progress"},[_c('span',{staticClass:"progress-meter",style:(`width: ${_vm.viewRatio}`)},[_vm._v(" ")])]),_c('span',[_vm._v(_vm._s(_vm.remainViewTime)+"분 남음")])])
}
var staticRenderFns = []

export { render, staticRenderFns }